<app-pinned-dashboard [title]="'My Pinned Items'">
  <div *ngIf="tiles.length==0" style="font-size: 21px;margin: 10px">No Items Pinned</div>
  <div style="grid-column: 1/3; background-color: white; overflow-y: auto;">
    <div>
      <app-pinned-tile-container [tiles]="tiles" class="flex-titles" [tileTemplate]="tileTemplate"
                                 [size]="'xlarge1'"></app-pinned-tile-container>
    </div>
    <ng-template #tileTemplate let-model="model">
      <div (click)="activateLink(model)" class="tile-content" *ngIf="model.title!='Diamond IP'">
        <div *ngIf="model.tile.title=='Whiteboards'">
          <div class="pinned-tile-content-header workspace-color text-wrap">
            {{ setTileTitle(model.tile.data.name) }}
          </div>
          <div class="tile-content-footer miro-color" style="font-size: 13px; bottom: 9px; color: #239EC1"> Owner: {{model.tile.data.owner}} </div>
        </div>

        <div *ngIf="(model.tile.title!='Workspace') && (model.tile.title !='Whiteboards') && (model.tile.title !='Ask The Experts')" class="pinned-tile-content-header application-color text-wrap app-desc" [ngStyle]="{'color':model.tile.color}" title="{{ model.text }}">
          {{ setTileTitle(model.text) }}
        </div>
        <div *ngIf="(model.tile.title =='Ask The Experts') && (model.tile.title !='Whiteboards')" class="pinned-tile-content-header application-color text-wrap app-desc" [ngStyle]="{'color':model.tile.color,'margin-bottom':'-10px'}" title="{{ model.text }}">
          {{ setTileTitle(model.text) }}
        </div>
        <div *ngIf="model.tile.title=='Workspace'" class="pinned-tile-content-header workspace-color text-wrap" [ngStyle]="{'color':model.tile.color}" title="{{ model.tile.data.name }}">
          {{ setTileTitle(model.tile.data.name) }}
        </div>
        <div class="pinned-tile-content-image">
          <img *ngIf="model.tile.title!='Workspace' && model.tile.title !== 'Task List' && model.tile.title !== 'Assessments' && (model.tile.title !='Whiteboards') " [src]="model.imageUrl" alt="The {{model.text}} image" class="adjust-img" />
          <img *ngIf="model.tile.title=='Workspace'" src="../../../../../assets/images/workbench/workbench-icon.png" alt="The {{model.text}} image" class="adjust-img" />
          <img *ngIf="model.tile.title=='Assessments'"  src="../../../../../assets/images/workbench/applications/AssessmentClipboard.svg" alt="The {{model.text}} image" class="adjust-img" />
          <img *ngIf="model.tile.title === 'Task List'"
               [src]="model.imageUrl"
               alt="The {{model.text}} image"
               class="tile-image adjust-img" />
        </div>


      </div>

      <div class="tile-content" *ngIf="model.title=='Diamond IP'">

        <div class="app-desc text-wrap" title="{{ model.name }}" (click)="viewTaxonomyFiles(model.packageId, model.packageType,model.name)">
          {{ setTileTitleForDiamondIp(model.name) }} ({{model.documentCount}})
        </div>
        <!--<div class="dtt-item-action">
          <div class="dtt-item-download" (click)="downloadSharepointFiles(model.packageId, model.packageType)"><i class="far fa-file-download" style="height: 22.5px"></i>Download</div>
          <div class="dtt-item-push" (click)="getTeamFolder(model.packageId)"><i class="fas fa-share-square fa-2x"></i>Push to Teams</div>
        </div>-->
      </div>


    </ng-template>
  </div>
  <div class="workspace-spinner-folder" style="display: none; z-index: 1000; ">
    <div class="" data-fa-i2svg="">
      <svg class="svg-inline--fa fa-spinner fa-w-16 fa-spin" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>
    </div>
  </div>
</app-pinned-dashboard>
